<template>
  <div>
    <h3 class="text-lerner-orange text-center">Select Date Range to Load Data</h3>
    <form autocomplete="off" v-on:submit.prevent="submit(form)" class="form report-form">
      <div class="flex items-center justify-center">
        <div class="col-4">
          <label>Begin Date <span>*</span></label>
          <datepicker
              v-model="form.begin_date"
              v-validate="'required|earlier'"
              name="begin_date"
              :format="format"
              :calendar-button="true"
          />
        </div>
        <div class="col-4">
          <label>End Date <span>*</span></label>
          <datepicker
              v-model="form.end_date"
              v-validate="'required|later'"
              name="end_date"
              :format="format"
              :calendar-button="true"
          />
        </div>
        <div class="col-lg-3 col-md-4">
          <button class="body-8 btn" :disabled="pending || errors.any()">Get Data</button>
        </div>
      </div>
      <div class="flex justify-center">
        <div class="col-4">
          <span class="error" v-if="errors.has('begin_date')">{{ errors.first('begin_date') }}</span>
        </div>
        <div class="col-4">
          <span class="error" v-if="errors.has('end_date')">{{ errors.first('end_date') }}</span>
        </div>
        <div class="col-lg-3 col-md-4"></div>
      </div>
    </form>
  </div>
</template>

<script>
  import moment from 'moment';
  import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js';

  export default {
    name: 'ReportForm',
    props: ['pending'],
    components: {
      Datepicker
    },
    created() {
      this.$validator.extend('earlier', {
        getMessage() {
          return 'The begin date field must be earlier than end date'
        },
        validate: (value) => {
          return moment(this.form.end_date).startOf('day') > moment(value).startOf('day');
        }
      });

      this.$validator.extend('later', {
        getMessage() {
          return 'the end date field must be later than start date'
        },
        validate: (value) => {
          return moment(this.form.begin_date).startOf('day') < moment(value).startOf('day');
        }
      })
    },
    data: function () {
      return {
        format: 'MM/dd/yyyy',
        form: {
          begin_date: moment().subtract(14, 'days').startOf('day').toDate(),
          end_date: moment().startOf('day').toDate(),
        }
      }
    },
    methods: {
      submit() {
        this.$validator.validate().then((valid) => {
          if (valid) {
            this.$emit('submit', this.form);
          }
        });
      }
    }
  };
</script>

<style lang="scss">
  .report-form {

    .vdp-datepicker__calendar-button {
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
      background-image: url('../../../assets/images/calendar-icon.svg');
      width: 16px;
      height: 18px;

      span i {
        display: none;
      }
    }

    .vdp-datepicker__calendar {
      @apply w-auto;

      span {
        transition: background .25s ease, border-color .25s ease;
        @apply text-black;
        font-style: normal;
      }

      .cell.selected,
      .cell.selected:hover,
      .cell.selected.highlighted {
        @apply bg-grey-3;
      }

      .cell:not(.blank):not(.disabled).day:hover,
      .cell:not(.blank):not(.disabled).month:hover,
      .cell:not(.blank):not(.disabled).year:hover {
        border-color: config('colors.grey-3');
      }

      header {
        .next:after {
          border-left-color: config('colors.grey-3');
        }

        .prev:after {
          border-right-color: config('colors.grey-3');
        }
      }
    }
  }
</style>
